module.exports = __webpack_public_path__ + "img/11@2x.4272dded.png";